// extracted by mini-css-extract-plugin
export default {"sticky-content":"_-web-client-js-react-components-___StickyWithScrollBack-module__sticky-content___k8UVQ"};